import {Component, Input} from "@angular/core";

@Component({
    selector: "collapse-form-child-header",
    template: require('./collapse.form.header.template.html')
})
export class CollapseFormHeaderComponent {
    @Input() id: number;
    @Input() title: string;
    @Input() even: boolean;
    @Input() disabled: boolean;
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/common/components/collapse/child/header/collapse.form.header.component.ts